module.exports = __webpack_public_path__ + "img/deactivate_icon.1b41e1a1.svg";